import React, { createContext, useContext, useEffect, useState } from 'react';

// Public-website language (Tamil / English). Components pick text with
// `tr(english, tamil)`; the choice is remembered per browser.
const STORAGE_KEY = 'eri_lang';

const readStored = () => {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'ta' || v === 'en' ? v : null;
  } catch {
    return null;
  }
};

const LanguageContext = createContext({
  lang: 'en',
  setLang: () => {},
  toggleLang: () => {},
  tr: (en) => en,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => readStored() || 'en');

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, lang); } catch { /* storage blocked — fine */ }
    document.documentElement.lang = lang;
  }, [lang]);

  const value = {
    lang,
    setLang,
    toggleLang: () => setLang((l) => (l === 'en' ? 'ta' : 'en')),
    tr: (en, ta) => (lang === 'ta' && ta ? ta : en),
  };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
